var map = {
	"./brown_1-6.png": "./src/assets/brown_1-6.png",
	"./green_1-6.png": "./src/assets/green_1-6.png",
	"./grey_1-6.png": "./src/assets/grey_1-6.png",
	"./red_1-6.png": "./src/assets/red_1-6.png",
	"./yellow_1-6.png": "./src/assets/yellow_1-6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*_1\\-6\\.png$";